import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Button from '../../components/Button';

import './styles.scss';

export default function Congratulations() {
  const history = useHistory();
  const { contactDetails, requestNumber, insuranceLogo } = useSelector(
    ({ user, insurancePolicies, insurances }) => ({
      contactDetails: user.contactDetails,
      requestNumber: insurancePolicies.requestNumber,
      insuranceLogo: insurances.selected && insurances.selected.logo,
    })
  );

  return (
    <div className='congratulations-container'>
      <div className='congratulations-card-wrapper'>
        <div className='congratulations-card-header-badge-outer'>
          <div className='congratulations-card-header-badge-middle'></div>
        </div>
        <div className='congratulations-card-header'>
          <div className='congratulations-card-header-badge'>
            <img src={insuranceLogo} alt='' />
          </div>
          <span className='congratulations-card-header-title'>
            ¡Felicitaciones,
            <br /> ya estás asegurado!
          </span>
        </div>
        <div className='congratulations-card-body'>
          <div className='congratulations-card-body-content'>
            <div className='congratulations-card-item'>
              Tu número de solicitud es <br />
              <b>{requestNumber}</b>
            </div>
            <div className='congratulations-card-item'>
              La solicitud fue enviada a <br />
              <b>{contactDetails.email}</b>
            </div>
          </div>
          <Button onClick={() => history.push('/')}>HOME</Button>
        </div>
      </div>
      <div className='congratulations-terms'>
        La póliza del seguro contratado será remitida por la compañia al correo
        electrónico declarado, dentro del plazo de 10 días hábiles. Por favor
        revise su carpeta de “correo no deseado”.
      </div>
    </div>
  );
}
